import React from 'react';
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

import { useSpinnerStyles } from './useSpinnerStyles';

export interface ISpinnerProps extends Omit<CircularProgressProps, 'color'> {
  isCentered?: boolean;
}

export function Spinner({
  isCentered = false,
  size,
  className,
}: ISpinnerProps): JSX.Element {
  const { classes, cx } = useSpinnerStyles();

  return (
    <Box
      className={cx(classes.root, isCentered && classes.centered, className)}
      height={size}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
